export class CustomParamsScreeningCriteriaModel {
  CriteriaID: number;
  OrganizationID: number;
}
